// @flow

import _ from 'lodash';
import React from 'react';
import cx from 'classnames';

export type NavType = {
  navHeader: string,
  navLinks: Array<{
    linkText: string,
    linkUrl: string,
    isCurrent: boolean,
  }>,
};

const ResourcesNav = ({ nav }: { nav: NavType }) => (
  <div className="resources-nav">
    <div className="header bold pad-y">{nav.navHeader}</div>
    <nav>
      {_.map(nav.navLinks, item => (
        <a
          key={item.linkText}
          className={cx('nav-item', { active: item.isCurrent })}
          href={item.linkUrl}>
          {item.linkText}
        </a>
      ))}
    </nav>
  </div>
);

export default ResourcesNav;
